import { useEffect, useState } from 'react';
import { iOS } from '../utils/env';
import { nativeApi } from '../utils/nativeApi';

const useStatusBarHeight = () => {
  const [statusBarHeight, setStatusBarHeight] = useState(28);

  useEffect(() => {
    const cssEnvName = iOS() ? '--iOS-safe-area-inset-top' : '--safe-area-inset-top';
    const tmpStatusBarHeight = getComputedStyle(
      document.querySelector('html') || document.createElement('div')
    ).getPropertyValue(cssEnvName);
    (async () => {
      setStatusBarHeight(
        (await nativeApi.getStatusBarHeight?.()) || Number.parseFloat(tmpStatusBarHeight) || 28
      );
    })();
  }, []);
  return [statusBarHeight];
};

export default useStatusBarHeight;
